import {mapGetters} from "vuex";
import * as queries from "../store/dss/queries";

/**
 * Mixin dss-subject.mixin.js
 *
 * @module dss-subject
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.10] app/src/APP_DASHBOARD/mixins/dss-subject.mixin.js
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  data: function () {
    return {
      loading: true,
      dssInfo: {},
    };
  },
  mounted() {
    this.refreshDssInfo();
  },
  computed: {
    ...mapGetters({
      patientId: "patientSummary/id",
    }),
    yesString : function(){
      return this.$ucfirst(this.$t('buttons.yes', {catalog : 'app_mobile'}))
    },
    noString : function(){
      return this.$ucfirst(this.$t('buttons.no', {catalog : 'app_mobile'}))
    },
    unknownString : function(){
      return this.$ucfirst(this.$t('dss.allergies.unknown'))
    }
  },
  watch: {
    patientId: function () {
      this.refreshDssInfo();
    },
  },
  methods: {
    refreshDssInfo() {
      this.dssInfo = {};
      this.loading = true;
      this.$app.apolloMobileClient
          .query({
            query: queries.getDssInfo,
            variables: {patientId: parseInt(this.patientId)},
          })
          .then((result) => {
            for (let [key, value] of Object.entries(result.data.myDSSInfo)) {
              this.$set(this.dssInfo, key, value);
            }
            this.loading = false;
          });
    },
    dssInputHumanFriendly(key, value) {
      if (value === null){
        return this.unknownString;
      }
      else if (typeof value === 'boolean') {
        return value ? this.yesString : this.noString;
      }
      else if (typeof value === 'string') {
        if (key === 'lastPCIDate') {
          return value.substr(0, 10);
        } else
          return this.$ucfirst(value);
      }
      return value;
    }
  },
};
